import { Modal } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { ApplicationsActions, selectIsRejectLoading, selectCurrentApplicationId } from "@redux";
import { i18, required, trb } from "@utilities";

export const RejectModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const isLoading = useSelector(selectIsRejectLoading);

  const handleRejectSubmit = async values => {
    await dispatch(
      ApplicationsActions.rejectApplication(
        appId,
        { overrideRisk: null, ...values },
        i18.NotificationTitles.SuccessOperation
      )
    );
    onClose();
  };

  return (
    <Form
      onSubmit={handleRejectSubmit}
      render={({ handleSubmit }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            <form id="rejectDocument" className="my-4" onSubmit={handleSubmit}>
              {isLoading ? (
                <ContentLoader />
              ) : (
                <FormField
                  name="comment"
                  component={FormFieldType.input}
                  title="Comment"
                  validate={required}
                  size="large"
                />
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
